export const aiData = {
  description: 'My work spans AI-powered backend systems, conversational workflows, and voice engineering — integrating LLMs, speech recognition, and telephony into production SaaS platforms.',
  tools: [
    {
      id: 'gemini',
      name: 'Google Gemini',
      category: 'LLM',
      description: 'Integrated Gemini for AI-driven workflow automation, content generation, and lead intelligence processing.',
    },
    {
      id: 'mcp',
      name: 'MCP',
      category: 'Protocol',
      description: 'Model Context Protocol for structured AI agent tool use and context management in agentic systems.',
    },
    {
      id: 'deepgram',
      name: 'Deepgram',
      category: 'Speech-to-Text',
      description: 'Real-time speech recognition for live call transcription and voice agent input processing.',
    },
    {
      id: 'elevenlabs',
      name: 'ElevenLabs',
      category: 'Text-to-Speech',
      description: 'AI voice synthesis for generating natural-sounding agent responses in conversational voice workflows.',
    },
    {
      id: 'assemblyai',
      name: 'AssemblyAI',
      category: 'Speech AI',
      description: 'Audio intelligence and transcription for post-call analysis, summaries, and speaker diarization.',
    },
    {
      id: 'ocr',
      name: 'OCR',
      category: 'Vision',
      description: 'Optical character recognition for extracting structured data from image-based document inputs.',
    },
  ],
  capabilities: [
    {
      title: 'AI-Powered Conversational Systems',
      description: 'Building multi-turn conversational workflows where AI handles lead qualification, intent detection, and dynamic responses.',
    },
    {
      title: 'Voice Agent Pipelines',
      description: 'Connecting telephony platforms (Twilio, Exotel, TCL) with speech-to-text, LLMs, and text-to-speech for end-to-end AI voice agents.',
    },
    {
      title: 'Live Transcription',
      description: 'Real-time audio streaming and transcription pipelines for in-call monitoring and interaction data capture.',
    },
    {
      title: 'AI Call Summaries & Lead Intelligence',
      description: 'Automated post-call processing: summarization, intent extraction, Next Best Action recommendations, and CRM updates.',
    },
    {
      title: 'Event-Driven AI Workflows',
      description: 'Designing RabbitMQ-based event pipelines that trigger AI processing jobs asynchronously across multi-tenant SaaS systems.',
    },
  ],
}
